import { render } from "./ButtonDomClose.vue?vue&type=template&id=ed24aef0"
import script from "./ButtonDomClose.vue?vue&type=script&lang=js"
export * from "./ButtonDomClose.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__